import { Hours } from '@obraplan/core/domain/shared/hours';
import type { TeamFrontMemberView } from '@obraplan/core/application/contracts/team-measurement';

/**
 * Quem trabalhou na frente × serviço da equipe, com as horas de cada um.
 *
 * Só leitura: na medição por equipe a quantidade é da equipe, mas as horas — como a ausência e
 * a hora extra — continuam sendo de cada pessoa (D1), e é no cartão dela que se ajustam. Aqui
 * elas aparecem para quem mede saber de quem é o dia que está medindo.
 *
 * Etiquetas que quebram de linha: no celular de 375 px o nome comprido não pode empurrar a
 * página para o lado.
 */
export function TeamFrontMembers({ members }: { members: readonly TeamFrontMemberView[] }) {
  if (members.length === 0) return null;
  return (
    <ul aria-label="Quem trabalhou" className="flex flex-wrap gap-1.5">
      {members.map((member) => (
        <li
          key={member.resourceId}
          className="flex max-w-full items-center gap-1.5 rounded-full border border-(--color-border-subtle) bg-(--color-surface-raised) px-2.5 py-0.5 text-xs"
        >
          <span className="min-w-0 truncate">{member.name}</span>
          <span className="tabular shrink-0 font-medium">
            {Hours.ofQuarters(member.quarterHours).format()}
          </span>
        </li>
      ))}
    </ul>
  );
}
